import { GraphToggle } from "@/components/GraphToggle";
import { Hint } from "@/components/portfolio/Hint";
import { RoundButtonWithSortingIcon } from "@/components/tools/RoundButtonWithSortingIcon";
import { RoundButtonWithToggleIcon } from "@/components/tools/RoundButtonWithToggleIcon";
import { useAnalysisContext } from "@/context/AnalysisContext";
import { useLanguage } from "@/context/LanguageContext";
import { useWatchDogContext } from "@/context/WatchDogContext";
import {BanknotesIcon, BeakerIcon, BuildingStorefrontIcon, CalendarDaysIcon} from "@heroicons/react/24/outline";
import {BanknotesIcon as BanknotesIconSolid, BeakerIcon as BeakerIconSolid, BuildingStorefrontIcon as BuildingStorefrontIconSolid, CalendarDaysIcon as CalendarDaysIconSolid} from "@heroicons/react/24/solid";
import { StarIcon } from "@heroicons/react/24/solid";
import {
  QueueListIcon,
  Squares2X2Icon,
  StarIcon as StarIconOutline,
} from "@heroicons/react/24/outline";
import React from "react";
import { RoundButtonsContainer } from "@/components/tools/RoundButtonsContainer";

export const EstateSorter: React.FC = ({}) => {
  const { language } = useLanguage();
  const copy = {
    cs: {
      detailedView: "Zobrazit detailní náhled",
      compactView: "Zobrazit kompaktní náhled",
      newest: "Seřadit od nejnovějšího",
      oldest: "Seřadit od nejstaršího",
      highestPrice: "Seřadit od nejvyšší ceny",
      lowestPrice: "Seřadit od nejnižší ceny",
      highestPriceSquare: "Seřadit od nejvyšší ceny za m²",
      lowestPriceSquare: "Seřadit od nejnižší ceny za m²",
      lowestSoftiqIndex: "Seřadit od nejnižší hodnoty SOFTIQ INDEX",
      highestSoftiqIndex: "Seřadit od nejvyšší hodnoty SOFTIQ INDEX",
      showAll: "Zobrazit vše",
      showFavorites: "Zobrazit oblíbené",
      favoritesHint: "Zobrazte si jen oblíbené položky",
    },
    en: {
      detailedView: "Show detailed view",
      compactView: "Show compact view",
      newest: "Sort by newest",
      oldest: "Sort by oldest",
      highestPrice: "Sort by highest price",
      lowestPrice: "Sort by lowest price",
      highestPriceSquare: "Sort by highest price per m²",
      lowestPriceSquare: "Sort by lowest price per m²",
      lowestSoftiqIndex: "Sort by lowest  SOFTIQ INDEX value",
      highestSoftiqIndex: "Sort by highest SOFTIQ INDEX value",
      showAll: "Show all",
      showFavorites: "Show favorites",
      favoritesHint: "Show only favorite items",
    },
  }[language];
  const {
    userInfoGlobal,
    isCompactView,
    setIsCompactView,
    sortState,
    handleSortChange,
    isFavoriteView,
    setIsFavoriteView,
  } = useWatchDogContext();
  const { isGraphView, setIsGraphView } = useAnalysisContext();

  return (
    <RoundButtonsContainer>
      {!isGraphView && (
        <>
          <RoundButtonWithToggleIcon
            icon={isCompactView ? Squares2X2Icon : QueueListIcon}
            isActive={false}
            onClick={() => setIsCompactView(!isCompactView)}
            tooltipTextActive={copy.detailedView}
            tooltipTextInactive={copy.compactView}
          />

          <RoundButtonWithSortingIcon
            icon={sortState.sortBy === "date" ? CalendarDaysIconSolid : CalendarDaysIcon}
            isActive={sortState.sortBy === "date"}
            ascending={sortState.ascending}
            onClick={() => handleSortChange("date")}
            tooltipTextAscending={copy.newest}
            tooltipTextDescending={copy.oldest}
          />
          <RoundButtonWithSortingIcon
            icon={sortState.sortBy === "softiqIndex" ? BeakerIconSolid : BeakerIcon}
            isActive={sortState.sortBy === "softiqIndex"}
            ascending={sortState.ascending}
            onClick={() => handleSortChange("softiqIndex")}
            tooltipTextAscending={copy.highestSoftiqIndex}
            tooltipTextDescending={copy.lowestSoftiqIndex}
          />
          <RoundButtonWithSortingIcon
            icon={sortState.sortBy === "pricePerSquareMeter" ? BuildingStorefrontIconSolid : BuildingStorefrontIcon}
            isActive={sortState.sortBy === "pricePerSquareMeter"}
            ascending={sortState.ascending}
            onClick={() => handleSortChange("pricePerSquareMeter")}
            tooltipTextAscending={copy.highestPriceSquare}
            tooltipTextDescending={copy.lowestPriceSquare}
          />
          <RoundButtonWithSortingIcon
            icon={sortState.sortBy === "price" ? BanknotesIconSolid : BanknotesIcon}
            isActive={sortState.sortBy === "price"}
            ascending={sortState.ascending}
            onClick={() => handleSortChange("price")}
            tooltipTextAscending={copy.highestPrice}
            tooltipTextDescending={copy.lowestPrice}
          />
        </>
      )}

      <RoundButtonWithToggleIcon
        icon={isFavoriteView ? StarIcon : StarIconOutline}
        isActive={isFavoriteView}
        onClick={() => setIsFavoriteView(!isFavoriteView)}
        tooltipTextActive={copy.showAll}
        tooltipTextInactive={copy.showFavorites}
        activeClassName="text-yellow-500 hover:text-yellow-500"
        inactiveClassName="text-yellow-500 hover:[&_svg]:fill-current"
      />
      <div className="absolute top-16 right-12 z-20">
        <Hint preference="watchdogFavoritesTip" text={copy.favoritesHint} />
      </div>

      <GraphToggle
        isGraphView={isGraphView}
        setIsGraphView={setIsGraphView}
        disabled={
          userInfoGlobal?.membership !== "PROFESSIONAL" &&
          userInfoGlobal?.membership !== "BASIC"
        }
      />
    </RoundButtonsContainer>
  );
};
